import { useTranslation } from 'react-i18next';

import type { MouseEventHandler } from 'react';

import type { Component } from '@bugbug/core/types/components';
import type { Test } from '@bugbug/core/types/tests';
import { useUnlinkComponentFromTest } from '~/modules/tests/hooks/useUnlinkComponentFromTest/useUnlinkComponentFromTest';

import * as S from './ToggleComponent.styled';

interface UnlinkComponentProps {
  testId: Test['id'];
  componentId: Component['id'];
}

export const UnlinkComponent = ({ testId, componentId }: UnlinkComponentProps) => {
  const [handleUnlinkComponent, unlinkComponentRequest] = useUnlinkComponentFromTest();
  const { t } = useTranslation();
  const tooltipContent = t(
    'makeComponent.infoComponent.tooltip',
    'All changes you make in this group will be reflected in all instances of this component.',
  );

  const handleUnlinkComponentClick: MouseEventHandler<HTMLButtonElement> = async (event) => {
    event.stopPropagation();
    await handleUnlinkComponent({ testId, componentId });
  };

  if (unlinkComponentRequest.isLoading) {
    return (
      <S.Wrapper>
        <S.Container data-testid="PendingComponent" disabled>
          <S.Loader />
          {t('makeComponent.unlink.pending.label', 'Unlinking...')}
        </S.Container>
      </S.Wrapper>
    );
  }

  return (
    <S.Wrapper>
      <S.Tooltip content={tooltipContent}>
        <S.Container data-testid="UnlinkComponent" onClick={handleUnlinkComponentClick} component>
          {t('makeComponent.unlink.label', '❖ Component')}
        </S.Container>
      </S.Tooltip>
    </S.Wrapper>
  );
};
